<template>
  <div class="service solution wrap">
    <SlotPageVisual class="half">
      <template #visual-bg>
        <div class="img solution"></div>
      </template>
      <template #contents>
        <h1 class="visual-title">
          <span data-aos="fade"><span class="hl">S</span>olution<br /></span>
        </h1>
        <p class="visual-summary">
          <span data-aos="fade-up" data-aos-delay="500">
            {{ $t('solution.desc.01') }}
          </span>
          <br />
          <span data-aos="fade-up" data-aos-delay="1000">
            {{ $t('solution.desc.02') }}
          </span>
        </p>
      </template>
    </SlotPageVisual>

    <MenuLinkGrid :items="solutionItems" />
  </div>
</template>

<script>
import SlotPageVisual from '@/components/SlotPageVisual'
import MenuLinkGrid from '@/components/MenuLinkGrid'

export default {
  name: 'SolutionView',
  components: { SlotPageVisual, MenuLinkGrid },
  computed: {
    solutionItems () {
      return [
        {
          title: this.$t('solution.title.nsddh'),
          sub: 'NS Dynamic Data Hub',
          desc: this.$t('solution.summary.nsddh'),
          to: '/solution/nsddh',
          accent: '#2563eb'
        },
        {
          title: this.$t('solution.title.iam'),
          sub: 'Identity and Access Management',
          desc: this.$t('solution.summary.iam'),
          to: '/solution/iam',
          accent: '#dc2626'
        },
        {
          title: this.$t('solution.title.sso'),
          sub: 'Single Sign On',
          desc: this.$t('solution.summary.sso'),
          to: '/solution/sso',
          accent: '#7c3aed'
        },
        {
          title: this.$t('solution.title.twoFactor'),
          sub: 'Two Factor Authentication',
          desc: this.$t('solution.summary.twoFactor'),
          to: '/solution/two-factor',
          accent: '#0891b2'
        },
        {
          title: this.$t('solution.title.isign'),
          sub: 'Secure Single Sign On',
          desc: this.$t('solution.summary.isign'),
          to: '/solution/isign',
          accent: '#059669'
        }
      ]
    }
  }
}
</script>
